import { type TranslationKey } from '#app/locales/uk.ts'

/**
 * The admin destinations, grouped — the single source of truth for BOTH admin
 * nav surfaces (the `lg`+ sidebar and the below-`lg` «Меню» dropdown). Data
 * only, on purpose: a rename or a move between groups is a one-array edit, and
 * neither surface has to be touched.
 *
 * Grouping ratified by the owner 2026-08-08 (straw-man from the IA consult);
 * the team's own words may still re-cut it — that is exactly the edit this
 * module is shaped to make cheap.
 *
 * `to` is a plain path string, as everywhere else in the header nav — these are
 * static routes, so a typed `href()` would buy nothing here.
 */

export type AdminNavItem = {
	to: string
	labelKey: TranslationKey
}

export type AdminNavGroup = {
	labelKey: TranslationKey
	items: AdminNavItem[]
}

export const adminNavGroups: AdminNavGroup[] = [
	{
		labelKey: 'nav.group.people',
		items: [
			{ to: '/applications', labelKey: 'nav.applications' },
			{ to: '/participants', labelKey: 'nav.participants' },
			// «Підказки кураторам» lives with People, not Learning: the work it
			// drives is contact/follow-up with people (owner ruling 2026-08-08)
			{ to: '/hints', labelKey: 'nav.hints' },
		],
	},
	{
		labelKey: 'nav.group.learning',
		items: [
			{ to: '/courses', labelKey: 'nav.courses' },
			{ to: '/templates', labelKey: 'nav.templates' },
		],
	},
	{
		labelKey: 'nav.group.money',
		items: [
			{ to: '/payments/inbox', labelKey: 'nav.paymentsInbox' },
			{ to: '/invoices', labelKey: 'nav.invoices' },
			{ to: '/salary', labelKey: 'nav.salary' },
			{ to: '/settings/salary-rates', labelKey: 'nav.salaryRates' },
			{ to: '/settings/fops', labelKey: 'nav.fops' },
		],
	},
	{
		labelKey: 'nav.group.system',
		// `/admin/cache` deliberately stays OUT of the nav: it is a maintenance
		// URL, reachable by typing it, not a destination staff navigate to
		items: [{ to: '/import', labelKey: 'nav.import' }],
	},
]
